<template>
  <div class="company-card__actions">
    <div
      :class="{ hold: companyStatus === 'hold' }"
      class="company-card__action company-card__action--receipt"
      @click.stop="goToAnalytics"
    >
      <div class="company-card__action-icon">
        <svg
          data-v-4a033b94=""
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            data-v-4a033b94=""
            d="M7.97551 1.6582C3.57044 1.65785 -0.000352888 5.22864 2.61576e-08 9.63372C-0.000352888 14.0388 3.57044 17.6096 7.97551 17.6092C12.3806 17.6096 15.9514 14.0388 15.951 9.63372L7.97551 9.63336V1.6582Z"
            fill="#E3E9FF"
          ></path>
          <path
            data-v-4a033b94=""
            d="M9.69202 1.04611e-07V7.97587H17.6675C17.6679 3.57044 14.0974 -0.000705724 9.69202 1.04611e-07Z"
            fill="#E3E9FF"
          ></path>
        </svg>
      </div>
      <div class="company-card__action-text">
        {{ $t('company_card.actions.analytics') }}
      </div>
    </div>
    <div
      :class="{ hold: companyStatus === 'hold' }"
      class="company-card__action company-card__action--payout"
      @click.stop="goToBills"
    >
      <div class="company-card__action-icon">
        <svg
          data-v-4a033b94=""
          width="13"
          height="17"
          viewBox="0 0 13 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            data-v-4a033b94=""
            d="M12.1333 0.107133L10.8333 1.59448L8.99167 0.107133C8.89813 0.0376569 8.78401 5.6811e-05 8.66667 5.6811e-05C8.54933 5.6811e-05 8.4352 0.0376569 8.34167 0.107133L6.5 1.59448L4.65833 0.107133C4.5648 0.0376569 4.45067 5.6811e-05 4.33333 5.6811e-05C4.216 5.6811e-05 4.10187 0.0376569 4.00833 0.107133L2.16667 1.59448L0.866667 0.107133C0.507812 -0.155144 0 0.0938532 0 0.532088V16.4679C0 16.9061 0.507812 17.1551 0.866667 16.8929L2.16667 15.4055L4.00833 16.8929C4.10187 16.9623 4.216 16.9999 4.33333 16.9999C4.45067 16.9999 4.5648 16.9623 4.65833 16.8929L6.5 15.4055L8.34167 16.8929C8.4352 16.9623 8.54933 16.9999 8.66667 16.9999C8.78401 16.9999 8.89813 16.9623 8.99167 16.8929L10.8333 15.4055L12.1333 16.8929C12.4888 17.1551 13 16.9061 13 16.4679V0.532088C13 0.0938532 12.4922 -0.155144 12.1333 0.107133ZM10.8333 11.9528C10.8333 12.0988 10.7115 12.2184 10.5625 12.2184H2.4375C2.28854 12.2184 2.16667 12.0988 2.16667 11.9528V11.4216C2.16667 11.2755 2.28854 11.156 2.4375 11.156H10.5625C10.7115 11.156 10.8333 11.2755 10.8333 11.4216V11.9528ZM10.8333 8.7656C10.8333 8.91168 10.7115 9.0312 10.5625 9.0312H2.4375C2.28854 9.0312 2.16667 8.91168 2.16667 8.7656V8.2344C2.16667 8.08833 2.28854 7.96881 2.4375 7.96881H10.5625C10.7115 7.96881 10.8333 8.08833 10.8333 8.2344V8.7656ZM10.8333 5.57843C10.8333 5.72451 10.7115 5.84403 10.5625 5.84403H2.4375C2.28854 5.84403 2.16667 5.72451 2.16667 5.57843V5.04724C2.16667 4.90116 2.28854 4.78164 2.4375 4.78164H10.5625C10.7115 4.78164 10.8333 4.90116 10.8333 5.04724V5.57843Z"
            fill="#E3E9FF"
          ></path>
        </svg>
      </div>
      <div class="company-card__action-text">
        {{ $t('company_card.actions.bills') }}
      </div>
    </div>
    <div
      :class="{ hold: companyStatus === 'hold' }"
      class="company-card__action company-card__action--iban-payout"
      @click.stop="goToPayouts"
    >
      <div class="company-card__action-icon">
        <svg
          data-v-4a033b94=""
          width="20"
          height="17"
          viewBox="0 0 20 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            data-v-4a033b94=""
            d="M10.7612 10.7754H6.72576L6.72576 1.3459H4.03546L4.03546 10.7754H0L4.67439 15.4381C5.06471 15.8275 5.69651 15.8275 6.08683 15.4381L10.7612 10.7754Z"
            fill="#E3E9FF"
          ></path>
          <path
            data-v-4a033b94=""
            d="M19.5046 5.36716L15.4692 5.36716V14.7967H12.7789V5.36716H8.74341L13.4178 0.704456C13.8081 0.315111 14.4399 0.315111 14.8302 0.704455L19.5046 5.36716Z"
            fill="#E3E9FF"
          ></path>
        </svg>
      </div>
      <div class="company-card__action-text">
        {{ $t('company_card.actions.payouts') }}
      </div>
    </div>
    <!--    <div class="company-card__action-add">-->
    <!--      <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">-->
    <!--        <line x1="1" y1="7" x2="13" y2="7" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round"/>-->
    <!--        <path d="M7 13.5L7 1" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round"/>-->
    <!--      </svg>-->
    <!--    </div>-->
  </div>
</template>

<script>
import { RouteHelper } from '@js-app/services/helpers/routes/routes-helper'

export default {
  name: 'CompanyCardActions',
  props: {
    companyStatus: {
      type: [String, Number],
    },
    company: {
      type: Object,
    },
  },
  methods: {
    goToAnalytics() {
      if (this.companyStatus !== 'hold') {
        this.$router.push(
          RouteHelper.getRoute('analytics', { companyId: this.company.ID })
        )
      } else {
        return
      }
    },
    goToBills() {
      if (this.companyStatus !== 'hold') {
        // this.$router.push(
        //   RouteHelper.getRoute('bills-list', { companyId: this.company.ID })
        // )
				this.$router.push(
          RouteHelper.getRoute('invoices-module', { companyId: this.company.ID })
        )
      } else {
        return
      }
    },
    goToPayouts() {
      if (this.companyStatus !== 'hold') {
        this.$router.push(
          RouteHelper.getRoute('payouts', { companyId: this.company.ID })
        )
      } else {
        return
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@css-app/variables';
@import '@css-app/mixins';
.company-card {
  &__actions {
    display: flex;
    align-items: stretch;
    overflow-x: auto;
  }

  &__action {
    padding: 17px;
    //padding: 12px 24px 12px 12px
    background-color: #fff;
    //background: #EBF2FF;
    border: 1px solid #f3f7ff;
    display: flex;
    align-items: center;
    height: 100%;
    cursor: pointer;
    width: 100%;
    justify-content: center;
    &-icon {
      svg {
        height: 12px;
        path {
          fill: #64748B;
        }
      }
    }

    &--receipt {
      background-color: #fff;
    }

    &--receipt & {
      &-icon {
        //background-color: #C9DBFF;
      }
    }

    &--payout {
      background-color: #fff;
    }

    &--payout & {
      &-icon {
        //background-color: #CDF0FF;
      }
    }

    &--iban-payout {
      background-color: #fff;
    }

    &--iban-payout & {
      &-icon {
        //background-color: #EFCDFF;
      }
    }

    &-icon {
      width: 26px;
      height: 26px;
      margin-right: 10px;

      border-radius: 8px;

      display: flex;
      align-items: center;
      justify-content: center;

      svg,
      img {
        max-width: 100%;
      }
    }

    &-text {
      font-size: pxToRem(12);
      line-height: pxToRem(15);
      font-weight: 600;
      //color: $label;
      color: black;
    }

    &-add {
      flex-shrink: 0;
      flex-grow: 0;
      width: 50px;
      height: 50px;
      background: #64748B;
      border-radius: 15px;

      display: flex;
      align-items: center;
      justify-content: center;

      img,
      svg {
        max-width: 100%;
        max-height: 100%;
      }
    }

    &.hold {
      cursor: not-allowed;
      opacity: 0.3;
    }

    &:hover {
      background-color: #64748B;
      .company-card__action-text {
        color: black;
      }

      .company-card__action-icon {
        svg {
          path {
            fill: #fff;
          }
        }
      }
    }
  }
}
</style>
